import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { DividendFilter } from "../../../data/reports/dividends/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const DividendsFilterChips: React.FunctionComponent<DividendsFilterChipsProps> = ({
  filter,
  removefilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);

  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("dateto")}
          />
        </Grid>
      )}
      {filter.security && (
        <Grid item>
          <Chip
            label={filter.security.secData}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("security")}
          />
        </Grid>
      )}
    </Grid>
  );
};

interface DividendsFilterChipsProps {
  filter: DividendFilter;
  removefilter: (type: keyof DividendFilter) => void;
}
